import CloseIcon from '@mui/icons-material/Close';
import type { DialogProps } from '@mui/material';
import {
  Dialog,
  DialogActions,
  DialogContent,
  useMediaQuery,
} from '@mui/material';
import React from 'react';

/* to use your custom dialog title : useCommonTitle should be false and title should be a JSX.Element
 also check the default props for dialog width and other features(BackdropClick & EscapeKeyDown) */

interface ICommonDialogProps extends DialogProps {
  actions: JSX.Element;
  onClose: () => void;
  'aria-labelledby'?: string;
  'aria-describedby'?: string;
  isCrossIcon: Boolean;
  customHeight?: string;
}

const InactiveCommonDialog = (props: ICommonDialogProps) => {
  const isSmScreen = useMediaQuery((theme: any) => theme.breakpoints.up('sm'));
  const {
    'aria-labelledby': ariaLabelledBy,
    'aria-describedby': ariaDescribedBy,
    children,
    disableEscapeKeyDown,
    fullWidth,
    maxWidth,
    isCrossIcon,
    onClose,
    actions,
    customHeight,
    open,
    ...rest
  } = props;

  return (
    <Dialog
      aria-labelledby={ariaLabelledBy}
      aria-describedby={ariaDescribedBy}
      // onClose={onClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      open={open}
      disableEscapeKeyDown={disableEscapeKeyDown}
      sx={{
        backdropFilter: 'blur(5px)',
      }}
      {...rest}
    >
      {isCrossIcon && (
        <div
          className="absolute right-6 top-4 z-10 cursor-pointer p-2"
          onClick={onClose}
        >
          <CloseIcon style={{ color: '#434349' }} className="pt-2" />
        </div>
      )}
      <DialogContent
        className={
          customHeight === 'AddUser'
            ? 'm-0 h-[360px] cursor-default !p-6'
            : 'm-0  cursor-default !p-6'
        }
      >
        {children}
      </DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
};

export default InactiveCommonDialog;

InactiveCommonDialog.defaultProps = {
  'aria-labelledby': undefined,
  'aria-describedby': undefined,
  actions: undefined,
  onClose: () => null,
  fullWidth: false,
  maxWidth: 'lg',
  useCommonTitle: true,
  isCrossIcon: true,
  disableEscapeKeyDown: true,
};
